import { createQueryClient } from '@fourthwall/utils/dist/queryClient';
import { Toasts } from '@fourthwall/components';
export const queryClient = createQueryClient({
    notify: (message) => Toasts.notify(message, { type: 'error' }),
});
